import React, { useMemo, useEffect } from 'react';
import { Observer } from 'mobx-react';
import { toJS } from 'mobx';
import { CustomSelect } from './CustomCreatableSelect';
import { MenuList, filterOptions } from './ReactSelectOverrides';
import { useRootStore } from '../../stores/BridgeProvider';

const AccountSelect = props => (
  <Observer
    render={() => {
      const { dataStore } = useRootStore();
      const {
        isValidAccountGroup,
        changeMemoVals,
        sortFunction,
        value,
        prefillDisabled,
        ...rest
      } = props;

      const accounts = dataStore.validAccountArray;

      const filteredAccounts = useMemo(() => {
        const groupedAccounts = [];
        accounts.forEach(account => {
          const { AccountTypeName, TypeId, BankAccountType } = account;
          if (
            isValidAccountGroup &&
            !isValidAccountGroup(TypeId, BankAccountType)
          ) {
            return;
          }
          const optionCategory = groupedAccounts.find(
            group => group.label === AccountTypeName,
          );
          if (!optionCategory) {
            groupedAccounts.push({
              label: AccountTypeName,
              id: TypeId,
              options: [account],
            });
          } else {
            optionCategory.options.push(account);
          }
        });
        return groupedAccounts;
      }, [accounts.length, changeMemoVals]);

      useEffect(() => {
        // If only one possible account option, then prepopulate with that account
        if (!prefillDisabled && !value && filteredAccounts.length === 1) {
          try {
            const category = filteredAccounts[0].options;
            if (category.length === 1) {
              props.onChange(category[0]);
            }
          } catch (e) {
            console.error(e);
          }
        }
      }, [filteredAccounts.length]);

      const customHeight = useMemo(
        () =>
          filteredAccounts.reduce((result, { options }) => {
            const valueToAdd = 15 + 40 * options.length;
            return result + valueToAdd;
          }, 10),
        [filteredAccounts],
      );

      const options =
        sortFunction && filteredAccounts.length !== 0
          ? sortFunction(filteredAccounts)
          : filteredAccounts;

      return (
        <CustomSelect
          isSearchable
          isClearable
          placeholder="Account"
          components={{
            MenuList: menuProps => (
              <MenuList
                {...menuProps}
                customHeight={
                  filteredAccounts.length > 0 &&
                  (customHeight > 300 ? 300 : customHeight)
                }
              />
            ),
          }}
          options={options.length > 0 ? options : ['No Accounts Available']}
          getOptionLabel={option =>
            options.length > 0
              ? `${option.AccountCode} - ${option.AccountName}`
              : `${option}`
          }
          getOptionValue={option => option.AccountId}
          filterOption={filterOptions}
          value={value}
          {...rest}
        />
      );
    }}
  />
);

export default AccountSelect;
